import { checkCircleOutlined, Icon } from '@surveycake/rc';
import { useSurveyConfig } from 'app/core/survey-config';
import React from 'react';
import { useStyles } from './styles';

function Completed() {
  const { wording } = useSurveyConfig();
  const styles = useStyles();

  return (
    <div className={styles.completed}>
      <Icon
        className={styles.completedIcon}
        size={2}
        icon={checkCircleOutlined}
      />
      <div>{wording.module.third_party_login.completed}</div>
    </div>
  );
}

export default Completed;
